import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { NotificationBarModel, NotificationBarTypes, NotificationSource } from './dashboard/notification-bar/notification-bar.model';
import { PaginationResult } from './pagination-result';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private url = environment.gatewayUrl;
  constructor(private httpClient: HttpClient) { }

  getNotificationsForCurrentUser():Observable<PaginationResult<NotificationDto>> {
    const params = new HttpParams().set('page', 1).set('pageSize', 50);
    return this.httpClient.get<PaginationResult<NotificationDto>>(`${this.url}current-user`, { params: params });
  }
}

export interface NotificationDto {
    id: number;
    data: NotificationDataDto
}

export interface NotificationViewModel{
  id: number;
  type: NotificationBarTypes;
  modules: NotificationSource[];
  htmlMessage: string;
  title?: string;
  from: Date;
  to: Date;
  closable: boolean;
}

export interface NotificationDataDto {
    type: NotificationBarTypes;
    modules: NotificationSource[];
    htmlMessage: string;
    title?: string;
    from: Date;
    to: Date;
    isClosable: boolean;
}